import type { Category } from '../models/issues/issue';

type SupportChannel = NonNullable<Category['supportChannel']>;

export const withSupportChannel = (
  supportChannel?: SupportChannel
): Partial<
  Record<
    'issue.support_channel.service_name' | 'issue.support_channel.type',
    string
  >
> => ({
  ...(supportChannel?.serviceName
    ? { 'issue.support_channel.service_name': supportChannel.serviceName }
    : {}),
  ...(supportChannel?.type
    ? { 'issue.support_channel.type': supportChannel.type }
    : {}),
});
